var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "stat-main"
  }, [_c('div', {
    staticClass: "stat-list"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("总用户数")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.user_total || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(0);
      }
    }
  }, [_vm.stepLoading[0] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])])]), _c('div', {
    staticClass: "stat-list"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("今日新增用户数")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.today_total || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(1);
      }
    }
  }, [_vm.stepLoading[1] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("昨日新增用户数")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.yestoday_total || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(2);
      }
    }
  }, [_vm.stepLoading[2] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("3日新增用户数")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.three_total || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(3);
      }
    }
  }, [_vm.stepLoading[3] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("7日新增用户数")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.week_total || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(4);
      }
    }
  }, [_vm.stepLoading[4] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("1个月新增用户数")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.month_total || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(5);
      }
    }
  }, [_vm.stepLoading[5] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])])]), _c('div', {
    staticClass: "stat-list"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("今日登录用户")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.today_login || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(6);
      }
    }
  }, [_vm.stepLoading[6] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("昨日登录用户")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.yestoday_login || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(7);
      }
    }
  }, [_vm.stepLoading[7] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("3日登录用户")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.three_login || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(8);
      }
    }
  }, [_vm.stepLoading[8] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("今日活跃(在线三分钟)")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.user_active || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(9);
      }
    }
  }, [_vm.stepLoading[9] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("今日人均在线")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(Math.round(_vm.statData.game_time / 60 * 100) / 100 || 0) + "分钟")]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(10);
      }
    }
  }, [_vm.stepLoading[10] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])])]), _c('div', {
    staticClass: "stat-list"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("今日签到")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.sign_in || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(11);
      }
    }
  }, [_vm.stepLoading[11] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("今日新人空投领取数")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(_vm.statData.drop_claim_count || 0))]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(12);
      }
    }
  }, [_vm.stepLoading[12] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "stat-item-tit"
  }, [_vm._v("今日新人空投领取率")]), _c('div', {
    staticClass: "stat-item-val"
  }, [_vm._v(_vm._s(Math.round(_vm.statData.drop_rate * 10000) / 100 || 0) + "%")]), _c('div', {
    staticClass: "stat-item-opt"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.getStepData(13);
      }
    }
  }, [_vm.stepLoading[13] ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])])]), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        !_vm.isLoading && _vm.onRefresh();
      }
    }
  }, [_vm.isLoading ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };